import { useMutation, useQueryClient } from '@tanstack/react-query';
import { msalInstance, useAuthStore } from '@sib/auth';
import { clearLocalStorage, storageKeys } from '@sib/utils';

interface UseLogoutProps {
  onLogout?: () => void;
}

export const useLogout = ({ onLogout }: UseLogoutProps = {}) => {
  const { setAccount } = useAuthStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      setAccount(null);
      await queryClient.cancelQueries();
      queryClient.clear();
      clearLocalStorage({ persistValueKeys: [storageKeys.userSetupStore] });
      sessionStorage.clear();
      await msalInstance.logoutRedirect({
        onRedirectNavigate: () => false,
      });
      onLogout?.();
      window.location.reload();
    },
  });
};
